import React, { useCallback, useEffect } from 'react'
import { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap'
import MultiSelect from "react-multiple-select-dropdown-lite";
import { ARRAYOFCountries } from './Products/CountriesArray';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { FaDownload, FaTrashAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
const AddAddress = () => {
  const [values, setValues] = useState({
    country: {
      en: "",
      ar: "",
      de: "",
      fr: "",
      ru: "",
      tur: "",
      cn: "",

      ir: "",
      dk: "",
    },
    state: {
      en: "",
      ar: "",
      fr: "",
      ru: "",
      tur: "",
      cn: "",
      de: "",
      ir: "",
      dk: "",
    },
    address: {
      en: "",
      ar: "",
      fr: "",
      ru: "",
      tur: "",
      cn: "",
      de: "",
      ir: "",
      dk: "",
    },
    email1: "",
    email2: "",
    phone1: "",
    phone2: "",
    hidden: "",
    img: ""

  });
  const { id } = useParams()
  const getAddressById = useCallback(async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `bearer ${localStorage.getItem("admin-token")}`
    );
    myHeaders.append("Content-Type", "application/json")
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders,
    };

    const response = await fetch(
      `https://www.api.setalkel.co/address/${id}`,
      requestOptions
    );
    const body = await response.json();
    console.log(body);
    setValues({
      state: {
        en: body?.state?.en,
        ar: body?.state?.ar,
        fr: body?.state?.fr,
        cn: body?.state?.cn,
        de: body?.state?.de,
        dk: body?.state?.dk,
        ir: body?.state?.ir,
        ru: body?.state?.ru,
        tur: body?.state?.tur


      },
      country: {
        en: body?.country?.en,
        ar: body?.country?.ar,
        fr: body?.country?.fr,
        cn: body?.country?.cn,
        de: body?.country?.de,
        dk: body?.country?.dk,
        ir: body?.country?.ir,
        ru: body?.country?.ru,
        tur: body?.country?.tur
      },
      address: {
        en: body?.address?.en,
        ar: body?.address?.ar,
        fr: body?.address?.fr,
        cn: body?.address?.cn,
        de: body?.address?.de,
        dk: body?.address?.dk,
        ir: body?.address?.ir,
        ru: body?.address?.ru,
        tur: body?.address?.tur
      },
      email1: body.email1,
      email2: body.email2,
      phone1: body.phone1,
      phone2: body.phone2,
      hidden: body.hidden,
      img: body.img
    })
    setImgfile(body.img)
    // console.log(ImgGallery.ImgGallery)
  }, [id]);
  useEffect(() => {
    id && getAddressById();
  }, [getAddressById]);
  const [imgFile, setImgfile] = useState("")
  const StateInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      state: { ...values.state, [name]: value.toLowerCase() },
    });
  };
  const CountryInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      country: { ...values.country, [name]: value.toLowerCase() },
    });
  };
  const AddressInputHandle = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      address: { ...values.address, [name]: value.toLowerCase() },
    });
  };

  const handleInfoInputChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  }

  const handleImageChange = async (e) => {
    setImgfile(e.target.files[0]);
      PostImg(e.target.files[0])
  };
  const PostImg = async (file) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `bearer ${localStorage.getItem("admin-token")}`
    );
    const formImg = new FormData()
    formImg.append("image", file)
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formImg,
      redirect: "follow",
    };
    const response = await fetch("https://www.api.setalkel.co/address/image", requestOptions)
    const body = await response.json();
    if (!response.ok) {
      console.log(body);
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        img: body._id,
      }));
    }
  }
  // useEffect(() => {
  //   if (imgFile) {
  //     PostImg()
  //   }
  // }, [imgFile])
  const navigate = useNavigate()
  const PostAddress = async () => {


    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `bearer ${localStorage.getItem("admin-token")}`
    );
    myHeaders.append(
      "Content-Type",
      `application/json`
    );
    const data = {
      ...values,
      img: values.img != "" ? id ? values.img.split('/').pop() : values.img : undefined
    }
    var requestOptions = {
      method: id ? "PUT" : "POST",
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: "follow",
    };
    const response = await fetch(`https://www.api.setalkel.co/address/${id ? id : ""}`, requestOptions)
    const body = await response.json();
    if (!response.ok) {
      console.log(body);
    } else {
      navigate("/dashboard/address")
      toast.success("Address has been Added :)");
    }
  }
  const getFile = async (file) => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    await fetch(`https://www.api.setalkel.co${file}`, requestOptions)
      .then((response) => response.blob())
      .then((blob) => {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement("a");
        link.href = url;

        // Extract the file extension from the file name
        const fileExtension = file.split('.').pop();

        // Define MIME types
        const mimeTypes = {
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          png: 'image/png',
          gif: 'image/gif',
          // add more MIME types as needed
        };

        // Set the download attribute with the correct file name and extension
        link.setAttribute("download", `${file}`);

        // If the MIME type is known, set it
        if (mimeTypes[fileExtension]) {
          link.type = mimeTypes[fileExtension];
        }

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => console.log("error", error));
  };
  const {t} = useTranslation()
  return (
    <section className="cms-create-products">
      <Row>
        <div className="crud-products">
          <div className="crud-title">
            <h1>{t('dashboard.address.addAddress')}</h1>
          </div>
        </div>
        <Form onSubmit={() => { }} className="products-form">
          {/* Country Section */}
          <Form.Group>
            <h4>{t('dashboard.address.country')}</h4>
            <div className="product-langs">
              <Form.Group>
                <Form.Label>{t('dashboard.address.countryNameEn')}</Form.Label>
                <Form.Control
                  name="en"
                  label="en"
                  value={values.country.en}
                  onChange={CountryInputHandle}
                  placeholder={t('dashboard.address.countryNameEnPlaceholder')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>{t('dashboard.address.countryNameAr')}</Form.Label>
                <Form.Control
                  name="ar"
                  label="ar"
                  value={values.country.ar}
                  onChange={CountryInputHandle}
                  placeholder={t('dashboard.address.countryNameArPlaceholder')}
                />
              </Form.Group>
            </div>
          </Form.Group>
          <hr />
          
          {/* State Section */}
          <h4>{t('dashboard.address.state')}</h4>
          <div className="product-langs">
            <Form.Group>
              <Form.Label>{t('dashboard.address.stateNameEn')}</Form.Label>
              <Form.Control
                name="en"
                label="en"
                value={values.state.en}
                onChange={StateInputHandle}
                placeholder={t('dashboard.address.stateNameEnPlaceholder')}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('dashboard.address.stateNameAr')}</Form.Label>
              <Form.Control
                name="ar"
                label="ar"
                value={values.state.ar}
                onChange={StateInputHandle}
                placeholder={t('dashboard.address.stateNameArPlaceholder')}
              />
            </Form.Group>
          </div>
          <hr />

          {/* Address Section */}
          <h4>{t('dashboard.address.address')}</h4>
          <div className="product-langs">
            <Form.Group>
              <Form.Label>{t('dashboard.address.addressNameEn')}</Form.Label>
              <Form.Control
                name="en"
                label="en"
                value={values.address.en}
                onChange={AddressInputHandle}
                placeholder={t('dashboard.address.addressNameEnPlaceholder')}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('dashboard.address.addressNameAr')}</Form.Label>
              <Form.Control
                name="ar"
                label="ar"
                value={values.address.ar}
                onChange={AddressInputHandle}
                placeholder={t('dashboard.address.addressNameArPlaceholder')}
              />
            </Form.Group>
          </div>
          <hr />

          {/* Contact Information Section */}
          <h4>{t('dashboard.address.contactInformation')}</h4>
          <div className="product-langs">
            <Form.Group>
              <Form.Label>{t('dashboard.address.email1')}</Form.Label>
              <Form.Control
                name="email1"
                label="email1"
                value={values.email1}
                onChange={handleInfoInputChange}
                placeholder={t('dashboard.address.email1Placeholder')}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('dashboard.address.email2')}</Form.Label>
              <Form.Control
                name="email2"
                label="email2"
                value={values.email2}
                onChange={handleInfoInputChange}
                placeholder={t('dashboard.address.email2Placeholder')}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('dashboard.address.phone')}</Form.Label>
              <Form.Control
                name="phone"
                label="phone"
                value={values.phone}
                onChange={handleInfoInputChange}
                placeholder={t('dashboard.address.phonePlaceholder')}
              />
            </Form.Group>
          </div>
          <hr />

          <Button onClick={PostAddress} variant='warning'>
            {id ? t('updateAddress') : t('addAddress')}
          </Button>
        </Form>
      </Row>
    </section>
  )
}

export default AddAddress